import api from '@/lib/axios';

class SettingsService {
  async getAutoSaveTimeout() {
    try {
      const response = await api.get('/settings');
      // Since response is an array, get the first item
      const settings = response.data[0];
      
      // Check if we have a valid setting object
      if (settings?.value) {
        return parseInt(settings.value) * 1000;
      } else if (settings?.default_value) {
        return parseInt(settings.default_value) * 1000;
      }
      
      return 7000; // Default fallback of 7 seconds
    } catch (error) {
      console.error("Error fetching auto-save settings:", error);
      return 7000; // Default fallback if API fails
    }
  }
}

export const settingsService = new SettingsService();